import { render, staticRenderFns } from "./DadosCPF.vue?vue&type=template&id=58b07a2c&scoped=true"
import script from "./DadosCPF.vue?vue&type=script&lang=js"
export * from "./DadosCPF.vue?vue&type=script&lang=js"
import style0 from "./DadosCPF.vue?vue&type=style&index=0&id=58b07a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b07a2c",
  null
  
)

export default component.exports